import { history } from "@src/history"
import axios from "axios"
import { apiErrorHandler }  from '@utils/apiErrorHandler';


const doLogin = (params, dispatch) =>{
    dispatch(params);
    getThumb(params.userAccount, dispatch);
    getNftList(params.userAccount, dispatch)
}
const getNftList = (userAccount, dispatch, prev_array = []) => {
    let name = userAccount+'';
    axios.get("https://wax.api.atomicassets.io/atomicassets/v1/assets", {
        params:{
            owner:name.replace('@owner', ''),
            collection_name:'battleminers',
            page: prev_array.length ? 2 : 1,
            limit:1000,
            order:'desc',
            sort:'asset_id'
        }
    })
    .then(response => {
        if(!prev_array.length && response.data.data.length == 1000){
            getNftList(userAccount, dispatch, response.data.data) 
        }else{
            if(prev_array.length) {
                response.data.data = [...response.data.data, ...prev_array]
            }
            dispatch({
                type: "GET_NFT_LIST",
                data: response.data.data
            });
        }
        
    })
}

const getThumb = (userAccount, dispatch)=>{
  try{
      axios.post("https://wax.pink.gg/v1/chain/get_table_rows", {
          "code": "wax.gg",
          "json": true,
          "limit": 1,
          "lower_bound": userAccount,
          "scope": "wax.gg",
          "table": "photos",
          "upper_bound": userAccount
      })
      .then(response => {
          dispatch({
              type: "GET_USER_THUMB",
              data: response.data.rows
          });
      })
  }catch(e){
      dispatch({
          type: "GET_USER_THUMB",
          data: []
      });
  }
}

export const requestNonce = () => {
  console.log('requestNonce')
  return dispatch => {
      dispatch({
          type: "REQUEST_NONCE"
      });
  }
}
export const oreLogin = (pubKeys, userAccount, isAutoLoginAvailable, callback =()=>{}, identity) => {
  localStorage.setItem('ore-login', JSON.stringify({pubKeys:pubKeys, userAccount:userAccount, isAutoLoginAvailable:isAutoLoginAvailable}));
  return dispatch => {
      //socket login pubKeys [] , userAccount str
      getThumb(userAccount, dispatch);
      doLogin({
          nl:true,
          type: "ORE_LOGIN",
          pubKeys:pubKeys,
          userAccount:userAccount,
          identity:identity
      }, dispatch)
      
      callback();
  }
}
export const waxLogin = (pubKeys, userAccount, isAutoLoginAvailable, callback =()=>{}, identity = null) => {
  console.log(['waxLogin', identity])
  localStorage.setItem('wax-login', JSON.stringify({pubKeys:pubKeys, userAccount:userAccount, isAutoLoginAvailable:isAutoLoginAvailable}));
  return dispatch => {
      getThumb(userAccount, dispatch);
      doLogin({
          nl:true,
          type: "WAX_LOGIN",
          pubKeys:pubKeys,
          userAccount:userAccount,
          identity:identity
      }, dispatch)

      callback();
  }
}

export const anchorLogin = (pubKeys, userAccount, callback =()=>{}, identity) => {
  return dispatch => {
      doLogin({
          nl:true,
          type: "ANCHOR_LOGIN",
          userAccount:userAccount,
          pubKeys:pubKeys,
          identity:identity
      }, dispatch)
      callback();
  }
}
export const wombatLogin = (pubKeys, userAccount, callback =()=>{}, identity = null) => {
  console.log('wombatLogin', pubKeys, userAccount)
  return dispatch => {
      doLogin({
          nl:true,
          type: "WOMBAT_LOGIN",
          userAccount:userAccount,
          pubKeys:pubKeys,
          identity:identity
      }, dispatch)
      callback();
  }
}
export const logout = () => {
  console.log('logout')
    localStorage.removeItem('wax-login');
    localStorage.removeItem('ssn');
    localStorage.removeItem('ore-login');
    window.location.href = window.location.href;
    return dispatch => {
        dispatch({
            type: "LOGOUT"
        });
        dispatch({
            type: "GET_NFT_LIST",
            data:[]
        });
    }
}
export const checkIfLoggedIn = (anchorSession = {}, wombatSession = {}) => {
  console.log('checkIfLoggedIn')
    let waxLogin = JSON.parse(localStorage.getItem('wax-login', null));
    if(waxLogin && waxLogin.isAutoLoginAvailable){
        return dispatch => {
            getThumb(waxLogin.userAccount, dispatch);
            doLogin({
                type: "WAX_LOGIN",
                pubKeys:waxLogin.pubKeys,
                userAccount:waxLogin.userAccount
            }, dispatch)
        }
    }
    if(anchorSession && anchorSession.userAccount){
        return dispatch => {
            getThumb(anchorSession.userAccount, dispatch);
            doLogin({
                type: "ANCHOR_LOGIN",
                userAccount:anchorSession.userAccount,
                pubKeys:anchorSession.pubKeys
            }, dispatch)
        }
    }
    if(wombatSession && wombatSession.userAccount){
      return dispatch => {
          getThumb(wombatSession.userAccount, dispatch);
          doLogin({
              type: "WOMBAT_LOGIN",
              userAccount:wombatSession.userAccount,
              pubKeys:wombatSession.pubKeys
          }, dispatch)
      }
  }
    let oreLogin = JSON.parse(localStorage.getItem('ore-login', null));
    if(oreLogin){
        return dispatch => {
            getThumb(oreLogin.userAccount, dispatch);
            doLogin({
                type: "ORE_LOGIN",
                pubKeys:waxLogin.pubKeys,
                userAccount:oreLogin.userAccount
            }, dispatch)
        }
    }
    return dispatch => {
        dispatch({
            type: "LOGOUT2"
        });
    }
}
export const loginWithJWTReset = user => {
  return dispatch => {
    dispatch({
        type: "RESET_LOGIN"
    });
  }
};


export const logoutWithJWT = () => {
  return dispatch => {
      axios
          .post("/api/v1/users/logout", {})
          .then(response => {
              history.push('/')
          })
          .catch(err => {
            dispatch(apiErrorHandler(err));
          });
  }
}
